import { GroupEntity } from '../../apis/group/group-entity';
import { TeamSettingEntity } from '../../apis/team/team-setting-entity';

// Assigns each group of a (multi-group) schedule a fixed background colour, in the order the groups
// first appear among the team settings. Shared by the schedule editor and the review page so both
// show the same colours and legend.
export class GroupColorScheme {
    private static readonly COLORS: string[] = [
        '#cce5ff', '#d4edda', '#fff3cd', '#f8d7da',
        '#e2d9f3', '#fde8d0', '#d6eaf8', '#d5f5e3',
    ];

    private readonly _colorByGroupId: Map<string, string> = new Map();
    private readonly _groups: GroupEntity[];

    constructor(teamSettings: TeamSettingEntity[] = [], groups: GroupEntity[] = []) {
        this._groups = groups ?? [];
        const uniqueGroupIds = [...new Set((teamSettings ?? []).map(t => t.groupId).filter(Boolean))];
        uniqueGroupIds.forEach((id, idx) => {
            this._colorByGroupId.set(id, GroupColorScheme.COLORS[idx % GroupColorScheme.COLORS.length]);
        });
    }

    // Colour strictly by the game's persisted groupId. Every schedule row is tagged with the group
    // it belongs to, so there is no name-based fallback (resolving by team name is ambiguous when
    // associations share a name across groups, e.g. "AIK 1" in both P11 and P13).
    public getColor(groupId: string): string {
        return this._colorByGroupId.get(groupId) ?? 'transparent';
    }

    public get legend(): { name: string; color: string }[] {
        return this._groups
            .map(g => ({ name: g.name, color: this._colorByGroupId.get(g.id) ?? '' }))
            .filter(e => e.color);
    }
}
